export interface PriceFromPriceListRequest {
  salesOrderHeaderId: string;
  productId: string;
  quantity: number;
  cutPrice: boolean;
  rrp: boolean;
  priceListUOMDescription: string;
  orderUnitOfMeasureDescription: string;
  currentPrice: number;
}
